import {resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import DoctorsService from "@services/DoctorsService";

export const viewDoctor = createAsyncThunk(
  "doctor/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await DoctorsService.viewDoctor({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const archiveDoctor = createAsyncThunk(
  "doctor/archive",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await DoctorsService.archiveDoctor({id});
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const unArchiveDoctor = createAsyncThunk(
  "doctor/restore",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await DoctorsService.unArchiveDoctor({id});
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const deleteDoctor = createAsyncThunk(
  "doctor/delete",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await DoctorsService.deleteDoctor({id});
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  doctor: null,
  error: "",
  serverStatus: "",
};

const viewDoctorSlice = createSlice({
  name: "view-doctor",
  initialState,
  reducers: {
    setError(state, action) {
      state.error = action.payload;
    },
    setServerStatus(state, action) {
      state.serverStatus = action.payload;
    },
    clearViewDoctor() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(viewDoctor.pending, (state) => {
        state.serverStatus = "loading";
      })
      .addCase(viewDoctor.fulfilled, (state, action) => {
        state.doctor =
          action.payload?.doctor_profile ?? action.payload ?? null;
        state.error = "";
        state.serverStatus = "success";
      })
      .addCase(viewDoctor.rejected, (state, action) => {
        state.error = action.payload?.message || "";
        state.serverStatus = "error";
      })

      .addCase(archiveDoctor.pending, (state) => {
        state.serverStatus = "loading";
      })
      .addCase(archiveDoctor.fulfilled, (state) => {
        state.serverStatus = "success";
        state.error = "";
      })
      .addCase(archiveDoctor.rejected, (state, action) => {
        state.error = action.payload?.message || "";
        state.serverStatus = "error";
      })

      .addCase(unArchiveDoctor.pending, (state) => {
        state.serverStatus = "loading";
      })
      .addCase(unArchiveDoctor.fulfilled, (state) => {
        state.serverStatus = "success";
        state.error = "";
      })
      .addCase(unArchiveDoctor.rejected, (state, action) => {
        state.error = action.payload?.message || "";
        state.serverStatus = "error";
      })

      .addCase(deleteDoctor.pending, (state) => {
        state.serverStatus = "loading";
      })
      .addCase(deleteDoctor.fulfilled, (state) => {
        state.serverStatus = "success";
        state.error = "";
      })
      .addCase(deleteDoctor.rejected, (state, action) => {
        state.error = action.payload?.message || "";
        state.serverStatus = "error";
      });
  },
});

export const {clearViewDoctor, setError, setServerStatus} =
  viewDoctorSlice.actions;
export default viewDoctorSlice.reducer;
